var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodEnergyProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 68 93.5",
    style: {
      enableBackground: "new 0 0 68 93.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ECBD65;}\n\t.st1{fill:#F8A087;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:0.663;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12.2,
    cy: 32.6,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 27.8,
    cy: 19.3,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 44.3,
    cy: 18.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 42,
    cy: 25,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 54.5,
    cy: 30.6,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 36.1,
    cy: 24.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 34.1,
    cy: 4.2,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 18.9,
    cy: 21.2,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 23.2,
    cy: 26.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 17.1,
    cy: 27.5,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 58,
    cy: 34.8,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 37.7,
    cy: 20,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 49.2,
    cy: 25.8,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 37.8,
    cy: 11.3,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 29.6,
    cy: 9.3,
    r: 2.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34,91.6c17.6,0,31.9-14.1,31.9-31.6c0-17.4-14.3-31.6-31.9-31.6S2.1,42.6,2.1,60C2.1,77.4,16.4,91.6,34,91.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32,37.8c0,0-0.2-2,1.7-2.8c1.9-0.8,2.9-0.2,2.9-0.2s0.6,0.3,1,1.1c0.4,0.8,0.7,0.9,0.9,1.4 c0.1,0.5,0.3,1.1,0.2,1.2c-0.1,0.2-0.3,0.5-0.1,0.8s0.4,0.5,0.4,0.8c-0.1,0.3-0.4,0.3-0.3,0.6c0.1,0.3,0,0.4,0,0.4 s0.1,0.4-0.2,0.5c-0.3,0.1-0.1,0.9-0.8,0.9c-0.7,0-1.2,0-1.2,0s1.9,0.6,2,1.1s0.3,1.1,0.3,1.9s0,1,0.1,1.6 c0.1,0.6,0.3,1.6,0.3,2.5c0,0.9,1.5,0.3,1.8-0.1s1-0.9,1-0.9s0.4-0.3,0.9-0.4s0.7-0.1,0.8,0.2c0,0,0.6-0.1,0.5,0.5 c-0.1,0.6,0,0.8-0.2,0.9c0,0,0.2,0.4-0.1,0.6c0,0-0.1,0.5-0.7,0.5c-0.6,0-1.5-0.3-2,0.1s-1.5,1.2-2.7,1.2c0,0-0.1,1-0.5,1.2 l-0.8,1.9c0,0-0.2,0.2-0.1,0.5s0.1,2-0.5,2.9L36,60.1c0,0,1.5,1.9,2.4,3.5s2,3.7,2,3.7s0.3,0.6,0.6,0.9c0.2,0.3,0.7,0.5,0.7,1.3 s-0.3,1.3-0.2,1.9c0.1,0.6,2.1,7.1,2.1,7.1s0.7,2.1,1.3,2.5s0.6,0,0.8,0.2c0.3,0.3,1.1,1.7,2,1.5c0.9-0.3,1.4-0.5,1.8,0 c0.3,0.5,0.2,0.8-0.7,1.3c-0.8,0.5-1.2,0.6-3,0.5c-1.8,0-3.2,0.9-3.7-0.2c-0.5-1.1-0.1-1.6-0.1-2.1c0-0.5-0.9-2.6-1.4-3.5 s-2-3.2-2.2-4.6c-0.2-1.4-0.1-4.1-1-4.6c-0.8-0.4-3-2.6-3.4-3.4c0,0-2,4.2-3.7,6.1c0,0-0.7,0.9-1.8,0.6c-1.1-0.3-2.4-1-4-1.5 s-2.5-1.2-5-1.8s-3.1-0.5-3.1-0.1c0,0.5-0.4,0.2-0.8,0s-2.1-0.4-3.3,0.6c0,0-0.2,0.3-0.7,0.1c-0.5-0.2-0.3-0.5-0.1-0.9 c0.2-0.3,0.9-1.6,2.9-2.8c2-1.2,2.6-1.7,2.9-1.6c0.3,0.1,0.7,1,1,1.1c0.2,0.2,0.3,0.5,0.1,0.8c0,0,3.4,0.5,4.7,0.5 c1.3,0,2,0,2.9,0.6c0.9,0.7,1.6,1.1,1.8,0.9c0.2-0.2,0.3-0.5,0.4-1c0.1-0.5,0.5-2.7,1.1-3.7c0.6-1,0.7-2,0.4-2.5 c-0.3-0.5-0.7-2,0.2-3.8c0.9-1.8,0.9-1.8,0.9-1.8s-0.4-0.4-0.6-0.7c-0.2-0.3-0.4-0.7-1.3-1.2s-4-2.2-4-3.3c-0.1-1.1,1.9-3,2.6-3.5 c0.7-0.5,1.4-0.8,1.7-1.5c0.3-0.7,1-1.5,1.9-1.9c1-0.4,1.7-1.1,1.9-1.6s0.4-0.9,0.1-1.8C32.8,39.8,32.1,38.7,32,37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.5,50.4c0,0,0.7-0.6,1.3-0.8c0.5-0.3,1.8-1.3,1.8-1.3s0.5,2.5,0.8,3.9s0.3,1.7,0,1.6 c-0.3-0.1-2.3-1.2-3.1-2.2C27.5,50.7,27.5,50.4,27.5,50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.3,35.8c0,0-0.5-1-1.5-0.5c-1,0.5-1.5,2-1,3.9c0.5,1.9,0.3,3.5-0.6,3.9c0,0,3.6-0.8,3.3-3.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodEnergyProfile);
export default __webpack_public_path__ + "static/media/Blood_Energy_Profile.4af6a832056396f1bdb46a759e292255.svg";
export { ForwardRef as ReactComponent };